import { render } from "./TDivider.vue?vue&type=template&id=584ed455"
import script from "./TDivider.vue?vue&type=script&lang=js"
export * from "./TDivider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__